import React from 'react';
import ItemWithTooltip from './ItemWithTooltip';
import { TimelineFeatureIcon } from '../../';
import { getIconTypeForWellbeingFeedback } from '../../utils/timeline';

type Props = {
  item: any;
  features: any;
  isSimple: boolean;
  isExpanded: boolean;
};

const WellbeingFeedbackFeatureIconItem: React.FC<Props> = ({
  item,
  features,
  isSimple,
  isExpanded,
}) => (
  <ItemWithTooltip item={item}>
    <TimelineFeatureIcon
      item={item}
      icon={
        features?.icons
          ? getIconTypeForWellbeingFeedback(
              features.icons,
              item.detail.value,
              item.event_name,
            )
          : null
      }
      isSimple={isSimple}
      isExpanded={isExpanded}
    />
  </ItemWithTooltip>
);

export default WellbeingFeedbackFeatureIconItem;
